<template>
  <div class="container">
    <el-carousel height="1020px" :interval="3000" :autoplay="true">
      <el-carousel-item v-for="(item,index) in swiperList" :key="index">
        <div class="swiper-item basic-padding-left-right"
        >
          <img class="tc-logo" src="@/static/images/swiper-logo.png"/>
          <img style="position: absolute;width: 100%;height: 100%;z-index: 1;top: 0;left: 0"
               :src="`${$imgUrl}swiper-bg-${index+1}.png`">
          <div class="main-text">
            {{ $t('swiperList.mainText', {mainText: $i18n.locale === 'en' ? item.mainTextEng : item.mainText}) }}
          </div>
          <div class="sub-text">
            {{ $t('swiperList.subText', {subText: $i18n.locale === 'en' ? item.subTextEng : item.subText}) }}
          </div>
          <div class="solve-btn" @click="jumpTo(item.path)">{{ $t('swiperList.buttonText') }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <contentBox>
      <div class="company-introduction-container">
        <div style="width: 620px;height: 150px;font-size: 18px">
          {{ $t('companyIntroduction.content') }}
        </div>
        <div style="display: flex;" :style="{marginTop: $i18n.locale === 'en' ? '120px' : '120px'}">
          <div class="corporate-mission"
          >
            <img style="position: absolute;width: 100%;height: 100%;z-index: 1;top: 0;left: 0"
                 v-lazy="`${$imgUrl}corporate-mission-bg.png`">
            <div class="company-introduction-title">{{ $t('corporateMission.title') }}</div>
            <div class="company-introduction-line"></div>
            <div class="company-introduction-subTitle">{{ $t('corporateMission.subTitle') }}</div>
          </div>
          <div class="corporate-values" :style="{ backgroundImage: `url(${$imgUrl}corporate-values-bg.png)` }"
          >
            <div class="company-introduction-title">{{ $t('corporateValues.title') }}</div>
            <div class="company-introduction-line"></div>
            <div class="corporate-values-list">
              <div class="corporate-values-item" v-for="(item,index) in corporateValuesList" :key="index">
                <img v-lazy="`${$imgUrl}${item.img}`">
                <div style="width: 100px;text-align: center;height: 40px" class="flex-center-column">
                  {{ $t('corporateValues.itemName', {itemName: $i18n.locale === 'en' ? item.titleEng : item.title}) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <img class="company-introduction-img" v-lazy="`${$imgUrl}company-introduction-main.png`">

      </div>
    </contentBox>
    <content-box :title="'核心技术'" :sub-title="'Core technology'"
                 :backgroundImgName="'coreTechnology'">
      <div class="technology-container">
        <div class="technology-list">
          <div class="technology-item" v-for="(item,index) in technologyList" :key="index" :style="{height: $i18n.locale === 'en' ? '555px' : ''}">
            <div class="technology-item-dark-bg"
                 :style="{ backgroundImage: `url(${$imgUrl}coreTechnology-icon-bg.png)` }">
            </div>
            <img v-lazy="`${$imgUrl}${item.mainIcon}`"
                 style="width: 70px;height: 70px;margin-top: 65px;z-index: 3;border-radius: 50%">
            <div class="technology-item-name">
              {{ $t('coreTechnology.title', {title: $i18n.locale === 'en' ? item.engName : item.name}) }}
            </div>
            <div class="technology-item-content">
              {{ $t('coreTechnology.content', {content: $i18n.locale === 'en' ? item.contentEng : item.content}) }}
            </div>
          </div>
        </div>
      </div>
    </content-box>
    <content-box :title="'核心产品与服务'" :whiteTitle="true" :sub-title="'Core products and services'" height="860px"
                 :backgroundImgName="'coreProductsAndServices'">
      <div class="core-products-and-services-container">
        <div class="core-products-and-services-left"
             @click="jumpTo('/solution/tongsuanCloud')"
             :style="{ backgroundImage: `url(${$imgUrl}coreProductsAndServices-left-bg.png)` }">
          <div class="core-products-and-services-left-title">
            <img v-lazy="`${$imgUrl}coreProductsAndServices-left-icon-1.png`">
            <div style="margin: 0 10px">
              {{ $t('coreProductsAndServices.leftTile') }}
            </div>
            <img v-lazy="`${$imgUrl}coreProductsAndServices-left-icon-2.png`">
          </div>
          <div class="core-products-and-services-left-subTitle">
            {{ $t('coreProductsAndServices.leftSubTile') }}
          </div>
          <div style="display: flex;align-items: center">
            <div class="core-products-and-services-left-item" style="color: #E0DBB8"
                 v-for="(item,index) in coreProductsAndServicesLeftList" :key="index">
              {{ $t('coreProductsAndServices.leftItem', {leftItem: $i18n.locale === 'en' ? item.engName : item.name}) }}
            </div>
          </div>
          <div
              style="display: flex;align-items: center;margin-top: 125px;width: 100%;justify-content: space-between;box-sizing: border-box;padding: 0 20px">
            <div class="core-products-and-services-left-type-item"
                 v-for="(item,index) in coreProductsAndServicesLeftTypeList" :key="index">
              <img v-lazy="`${$imgUrl}${item.mainIcon}`">
              <div style="width: 120px;text-align: center;line-height: 20px;height: 80px">
                {{
                  $t('coreProductsAndServices.leftTypeItem', {leftTypeItem: $i18n.locale === 'en' ? item.engName : item.name})
                }}
              </div>
            </div>

          </div>
        </div>
        <div class="core-products-and-services-right">
          <div class="core-products-and-services-right-item" :style="{marginBottom:index?'0':'20px'}"
               v-for="(item,index) in coreProductsAndServicesRightList" :key="index"  @click="jumpTo(item.path)">
            <div class="flex-start-column" style="width: 400px;">
              <div class="flex-align-row">
                <img class="logo" v-lazy="`${$imgUrl}coreProductsAndServices-right-item-${index+1}-logo.png`"/>
                <div class="core-products-and-services-right-title">
                  {{
                    $t('coreProductsAndServices.rightTile', {rightTile: $i18n.locale === 'en' ? item.engTitle : item.title})
                  }}
                </div>
              </div>
              <div class="core-products-and-services-right-subTitle">
                {{
                  $t('coreProductsAndServices.rightSubTile', {rightSubTile: $i18n.locale === 'en' ? item.engSubTitle : item.subTitle})
                }}
              </div>
              <div class="flex-align-row " :style="{marginTop:$i18n.locale === 'en' ?'25px':'60px'}">
                <div class="core-products-and-services-right-type" v-for="(type,index2) in item.typeList" :key="index2">
                  {{
                    $t('coreProductsAndServices.rightItem', {rightItem: $i18n.locale === 'en' ? type.engName : type.name})
                  }}
                </div>
              </div>
            </div>
            <div class="core-products-and-services-right-steps"
                 :style="{ backgroundImage: `url(${$imgUrl}coreProductsAndServices-right-item-bg.png)` }">
              <div v-for="(step,index3) in item.stepsList" :key="index3">
                <div class="flex-align-row">
                  <div class="core-products-and-services-right-steps-circle"></div>
                  <div style="width: 170px;">
                    {{
                      $t('coreProductsAndServices.rightStepItem', {rightStepItem: $i18n.locale === 'en' ? step.engName : step.name})
                    }}
                  </div>
                </div>
                <div class="core-products-and-services-right-steps-line" v-if="index3+1!==item.stepsList.length"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </content-box>
    <content-box :title="'核心目标'" :sub-title="'Core objectives'" height="870px" style="padding-right: 0!important;">
      <div class="core-objectives-container" :style="{ backgroundImage: `url(${$imgUrl}core-objectives-bg.png)` }">
        <div class="core-objectives-list">
          <div class="core-objectives-item" v-for="(item,index) in coreObjectivesList" :key="index">
            <div class="core-objectives-item-title">
              {{ $t('coreObjectives.title', {title: $i18n.locale === 'en' ? item.engName : item.name}) }}
            </div>
            <div class="core-objectives-item-percent" v-if="index===0">
              <div style="font-size: 24px;margin-bottom: 5px;margin-left: 5px"> ></div>
              200
              <div style="font-size: 24px;margin-bottom: 5px;margin-left: 5px">
                {{ $i18n.locale === 'en' ? 'times' : '倍' }}
              </div>
            </div>
            <div class="core-objectives-item-percent" v-if="index===1">
              4
              <div style="font-size: 24px;margin-bottom: 5px;margin-left: 5px">%</div>
              <div style="margin: 0 5px">~</div>
              8
              <div style="font-size: 24px;margin-bottom: 5px;margin-left: 5px">%</div>
            </div>
            <div class="core-objectives-item-percent" v-if="index===2">
              <div style="font-size: 24px;margin-bottom: 5px;margin-right: 5px"> ></div>
              2
              <div
                  style="font-size: 14px;margin-bottom: 5px;margin-left: 5px;color: rgba(255,255,255,0.55);font-weight: normal">
                {{ $i18n.locale === 'en' ? 'million tons' : '亿吨' }}
              </div>
            </div>
            <div class="core-objectives-item-subTitle">
              {{ $t('coreObjectives.subTitle', {subTitle: $i18n.locale === 'en' ? item.engSubTitle : item.subTitle}) }}
            </div>
          </div>
        </div>
        <img class="core-objectives-title-img" v-lazy="`${$imgUrl}core-objectives-title.png`"/>
      </div>
    </content-box>
    <content-box :title="'最新资讯'" :sub-title="'Latest news'" :backgroundImgName="'latestNews'" height="1015px">
      <div class="latest-news-container">
        <div class="latest-news-left" v-if="newsListMain" @click="gotoDetails(newsListMain.id)">
          <img style="object-fit:cover" v-lazy="newsListMain.image"/>
          <div class="latest-news-left-title">{{ $i18n.locale === 'en' ?newsListMain.titleEng:   newsListMain.title }}</div>
          <div class="latest-news-left-date">{{ new Date(newsListMain.publishTime).toLocaleDateString() }}</div>
          <div class="latest-news-left-moreBtn" >
            {{ $t('latestNews.more') }}
          </div>
        </div>
        <div class="latest-news-right" v-if="newsList.length>0">
          <div class="latest-news-right-item" v-for="(item,index) in newsList" :key="index"
               @click="gotoDetails(item.id)">
            <div class="latest-news-right-item-info">
              <div>
                <div class="latest-news-right-item-info-title">{{ $i18n.locale === 'en' ?item.titleEng:  item.title }}</div>
                <div class="latest-news-right-item-info-date"> {{
                    new Date(item.publishTime).toLocaleDateString()
                  }}
                </div>
              </div>
              <div class="latest-news-right-item-info-more">
                {{ $t('latestNews.more') }}
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <img style="object-fit:cover" v-lazy="item.image"/>
          </div>

        </div>
      </div>
    </content-box>
    <content-box :title="'合作伙伴'" :sub-title="'Partners'" height="920px">
      <div class="partners-container">
<!--        <img v-for="item in 12" v-lazy="`${$imgUrl}partners-${item}.png`"/>-->
        <img  v-lazy="`${$imgUrl}partners-14.png`"/>
        <img  v-lazy="`${$imgUrl}partners-13.png`"/>
        <img  v-lazy="`${$imgUrl}partners-2.png`"/>
        <img  v-lazy="`${$imgUrl}partners-3.png`"/>
      </div>
    </content-box>
  </div>


</template>

<script>
// @ is an alias to /src
import * as echarts from 'echarts';
import contentBox from "@/components/contentBox.vue";
import * as url from "url";

export default {
  name: 'HomeView',
  computed: {
    url() {
      return url
    }
  },
  components: {contentBox},
  metaInfo: {
    title: '砼程数智', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '宁波砼程数智科技有限公司'
    },
      {
        name: 'description',
        content: '宁波砼程数智科技有限公司，创立于2023年，致力于通过前沿的AI技术，构建混凝土产业数字化共享平台。携手合伙人，共同推动混凝土行业的智能、绿色、可持续发展'
      }],
    link: [{ // set link
      rel: 'asstes',
      href: 'http://pc.tongctec.com/'
    }]
  },
  data() {
    return {
      swiperList: [
        {
          backgroundImage: require('@/static/images/swiper-bg-1.png'),
          mainText: '砼行筑梦 砼创未来',
          mainTextEng: 'Concrete builds dreams and creates the future',
          subText: '“AI+”，重塑混凝土行业生态',
          subTextEng: '"AI+" reshapes the ecology of the concrete industry',
          path: '/solution/tongsuanCloud',
        },
        {
          backgroundImage: require('@/static/images/swiper-bg-2.png'),
          mainText: '携手并肩 创新致远',
          mainTextEng: 'Collaborate to drive innovation',
          subText: '混凝土未来，你我共筑',
          subTextEng: 'A solid future is constructed by both of us',
          path: '/solution/tongsuanCloud',
        },
        {
          backgroundImage: require('@/static/images/swiper-bg-3.png'),
          mainText: '赋能传统 引领变革',
          mainTextEng: 'Empower tradition to lead change',
          subText: '助力碳中和，推动碳交易',
          subTextEng: 'Help carbon neutrality and promote carbon trading',
          path: '/solution/functionalAdditives',
        }
      ],
      corporateValuesList: [
        {
          img: 'corporate-values-icon-1.png',
          title: '需求引领',
          titleEng: 'Demand-led',

        },
        {
          img: 'corporate-values-icon-2.png',
          title: '创新驱动',
          titleEng: 'Innovation Driver',
        },
        {
          img: 'corporate-values-icon-3.png',
          title: '共创共享',
          titleEng: 'Create and share',

        },
        {
          img: 'corporate-values-icon-4.png',
          title: '追求卓越',
          titleEng: 'Pursue excellence',
        }
      ],
      technologyList: [
        {
          mainIcon: 'coreTechnology-icon-1.png',
          name: "人工智能",
          engName: "Artificial Intelligence",
          content: "基于人工智能技术，对数据集进行挖掘分析，实现对混凝土配合比的自动设计与优化",
          contentEng: "Based on artificial intelligence technology, mining and analysis of data sets to achieve automatic design and optimization of concrete mixing ratios",
        },
        {
          mainIcon: 'coreTechnology-icon-2.png',
          name: "图像算法",
          engName: "Image algorithm",
          content: "采用图像识别技术及深度学习算法，智能检测骨料含水率、级配、圆形度、孔隙率、含粉量等",
          contentEng: "Adopting image recognition technology and deep learning algorithm, intelligent detection of aggregate water content, grading, roundness, porosity, powder content and so on"
        },
        {
          mainIcon: 'coreTechnology-icon-3.png',
          name: "外加剂研发",
          engName: "Admixture",
          content: "基于水化机理、高分子聚合技术等的研究，不断优化外加剂性能和工艺，进一步降低混凝土水胶比，提高和易性、耐久性",
          contentEng: "Based on the research of hydration mechanism, polymer polymerization technology, etc., continuously optimize the performance and process of admixtures to further reduce the water-cement ratio of concrete and improve the ease of use and durability"
        },

        {
          mainIcon: 'coreTechnology-icon-4.png',
          name: "物联网技术",
          engName: "Internet of Things technology",
          content: "通过图像、红外、微波等各类传感器，结合5G通信、边缘计算等技术、将科技融入实际生产过程从而降低成本和资源消耗",
          contentEng: "Through various collection and control sensors, mobile communication, intelligent analysis and other technologies are integrated into the actual production process to reduce costs and resource consumption"

        }],
      coreProductsAndServicesLeftList: [
        {name: "AI算法", engName: "AI algorithm"},
        {name: "大数据", engName: "Big data"},
        {name: "机器学习", engName: "AI learning"},

      ],
      coreProductsAndServicesLeftTypeList: [
        {name: "配合比AI模型", engName: "Mix ratio AI model", mainIcon: 'coreProductsAndServices-left-icon-3.png'},
        {
          name: "智能检测设备",
          engName: "Intelligent detection equipment",
          mainIcon: 'coreProductsAndServices-left-icon-4.png'
        },
        {name: "数智原材料", engName: "Digital Raw Materials", mainIcon: 'coreProductsAndServices-left-icon-5.png'},
      ],
      coreProductsAndServicesRightList: [
        {
          title: "砼逸家", engTitle: "TongYiJia", subTitle: "外加剂产业链的信息与交易服务平台",
          engSubTitle: "Admixture industry chain information and trading service platform",
          typeList: [
            {name: "个性化", engName: "Personalized"},
            {name: "智能化", engName: "Intellectualize"},
            {name: "在线化", engName: "Online"},
          ],
          stepsList: [
            {name: "定制研发", engName: "Customized R&D"},
            {name: "智慧工厂", engName: "Smart Factory"},
            {name: "定制生产", engName: "Customized production"},
            {name: "交易系统", engName: "Trading system"},
          ],
          path:'/solution/tongyijia'
        },
        {
          title: "功能性外加剂", engTitle: "Functional admixtures", subTitle: "研发特殊性能需求的外加剂",
          engSubTitle: "Develop admixtures with special performance requirements",
          typeList: [
            {name: "尖端人才 ", engName: "Cutting-edge talent"},
            {name: "核心技术", engName: "Core technology"},
            {name: "研发投入", engName: "R&D investment"},
          ],
          stepsList: [
            {name: "优化胶材用量", engName: "Optimizing the amount of glue"},
            {name: "满足多种施工要求", engName: "Meet higher construction requirements"},
            {
              name: "助力双碳及碳交易",
              engName: "Contributing to Dual Carbon and Carbon Trading"
            },
          ],
          path:'/solution/functionalAdditives'
        },
      ],
      coreObjectivesList: [
        {
          name: "",
          engName: "",
          subTitle: "提升检测效率",
          engSubTitle: "Improve detection efficiency"
        },
        {
          name: "",
          engName: "",
          subTitle: "降低原材料生产成本",
          engSubTitle: "Reduce the cost"
        },
        {
          name: "",
          engName: "",
          subTitle: "减少二氧化碳排放",
          engSubTitle: "Reduction of carbon dioxide emissions"
        },
      ],
      partnersList: [],
      newsListMain:{},
      newsList: [],

    }
  },
  mounted() {
    this.getNewsList()
  },
  methods: {
    gotoDetails(id) {
      // this.$router.push({
      //   path: `/newsDetails?id=${id}`,
      // })
      // console.log('http://'+window.location.hostname+`/newsDetails?id=${id}`)
      window.open('http://'+window.location.hostname+`/newsDetails?id=${id}&languageModel=${this.$i18n.locale}`)
    },
    jumpTo(path){
      this.$router.push({
        path,
      })
    },
    getNewsList() {
      let data = {
        page: 1,
        pageSize: 4
      }
      this.$api.getNewsList(data).then(res => {
        console.log(res)
        if (res.status === 0) {
          this.newsListMain = res.data.records[0]
          if(res.data.records.length>1){
            this.newsList = res.data.records.slice(1)
          }else{
            this.newsList = res.data.records
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.container {
  user-select: none;
  display: flex;
  flex-direction: column;

  .swiper-item {
    width: 100%;
    height: 100%;
    color: black;
    display: flex;
    flex-direction: column;
    background-size: 100% 100%;
    box-sizing: border-box;

    .tc-logo {
      margin-top: 315px;
      width: 130px;
      height: 80px;
    }

    .main-text {
      font-weight: 600;
      font-size: 64px;
      color: #FFFFFF;
      line-height: 90px;
      z-index: 2;
    }

    .sub-text {
      font-weight: 400;
      font-size: 18px;
      color: #6D7378;
      z-index: 2;
    }

    .solve-btn {
      margin-top: 90px;
      width: 175px;
      height: 45px;
      border-radius: 2px;
      border: 1px solid #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 25px;
      cursor: pointer;
      z-index: 2;
    }
  }

  .company-introduction-container {
    min-width: 1300px;
    margin-top: 215px;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 29px;
    position: relative;

    .company-introduction-title {
      font-weight: 500;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.85);
      line-height: 28px;
      z-index: 1;
    }

    .company-introduction-line {
      margin-top: 7px;
      margin-bottom: 12px;
      width: 19px;
      height: 2px;
      background: #EEEEEE;
      z-index: 1;
    }

    .company-introduction-subTitle {
      font-weight: 400;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.65);
      line-height: 22px;
      z-index: 1;
    }

    .corporate-mission {
      width: 210px;
      height: 240px;
      box-sizing: border-box;
      padding: 25px;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .corporate-values {
      margin-left: 25px;
      width: 580px;
      height: 240px;
      box-sizing: border-box;
      background-size: 100% 100%;
      padding: 25px;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;

      .corporate-values-list {
        display: flex;
        align-items: center;
        flex: 1;
        box-sizing: border-box;
        padding: 0 15px;
        justify-content: space-between;

        .corporate-values-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-weight: 400;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 22px;

          img {
            width: 70px;
            height: 70px;
            margin-bottom: 20px;
            border-radius: 50%;
          }
        }
      }
    }

    .company-introduction-img {
      width: 565px;
      height: 600px;
      background-size: 100% 100%;
      position: absolute;
      right: -45px;
      top: -105px;
    }
  }

  .technology-container {
    .technology-list {
      margin-top: 300px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .technology-item {
        width: 340px;
        height: 450px;
        padding-bottom: 30px;
        display: flex;
        align-items: center;
        flex-direction: column;
        background-color: white;
        position: relative;

        .technology-item-dark-bg {
          position: absolute;
          top: 0;
          width: 100%;
          height: 185px;
          z-index: 1;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }


        .technology-item-name {
          font-weight: 500;
          font-size: 24px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 33px;
          z-index: 4;
          margin-top: 80px;
          text-align: center;
        }

        .technology-item-content {
          width: 210px;
          font-weight: 400;
          font-size: 18px;
          color: rgba(0, 0, 0, 0.65);
          line-height: 24px;
          z-index: 4;
          margin-top: 20px;
        }
      }
    }
  }

  .core-products-and-services-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 270px;
    width: 100%;

    .core-products-and-services-left {
      height: 480px;
      width: 710px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      padding: 40px;
      background-size: 100% 100%;
      cursor: pointer;
      .core-products-and-services-left-title {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 28px;
        color: #ECE196;

        img {
          width: 25px;
          height: 25px;
        }
      }

      .core-products-and-services-left-subTitle {
        font-weight: 400;
        font-size: 18px;
        color: #DFD8AD;
        margin-top: 10px;
        margin-bottom: 25px;
      }

      .core-products-and-services-left-item {
        padding: 10px 30px;
        border: 1px solid #60605C;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 12px;
        color: #E0DBB8;
        margin-right: 10px;
      }

      .core-products-and-services-left-type-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);

        img {
          width: 70px;
          height: 70px;
          margin-bottom: 15px;
        }
      }
    }

    .core-products-and-services-right {
      display: flex;
      flex-direction: column;
      width: 710px;

      .core-products-and-services-right-item {
        width: 100%;
        height: 230px;
        background: rgba(77, 79, 84, 0.7);
        box-sizing: border-box;
        padding-left: 35px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .logo {
          width: 30px;
          height: 45px;
          margin-right: 10px;
        }

        .core-products-and-services-right-title {
          font-weight: 500;
          font-size: 24px;
          color: #FFFFFF;
        }

        .core-products-and-services-right-line {
          width: 19px;
          height: 3px;
          background: #FFFFFF;
          margin-top: 10px;
        }

        .core-products-and-services-right-subTitle {
          font-weight: 500;
          width: 300px;
          font-size: 18px;
          color: #929292;
          margin-top: 15px;
        }

        .core-products-and-services-right-type {
          min-width: 100px;
          padding: 0 10px;
          height: 30px;
          border: 1px solid rgba(151, 151, 151, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-size: 12px;
          color: #C3C3C3;
          margin-right: 10px;
        }

        .core-products-and-services-right-steps {
          display: flex;
          flex-direction: column;
          font-weight: 400;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.85);
          height: 100%;
          width: 275px;
          background-size: 100% 100%;
          align-items: flex-end;
          justify-content: center;

          .core-products-and-services-right-steps-circle {
            width: 13px;
            height: 13px;
            border: 1px solid #979797;
            border-radius: 50%;
            margin-right: 10px;
          }

          .core-products-and-services-right-steps-line {
            width: 1px;
            height: 29px;
            border-left: 1px solid #434343;
            margin-left: 7px;
            margin-top: 5px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }

  .core-objectives-container {
    margin-top: 280px;
    box-sizing: border-box;
    width: 100%;
    height: 440px;
    background: #2D3349;
    display: flex;
    align-items: center;
    padding-left: 145px;
    background-size: 100% 100%;
    position: relative;
    .core-objectives-title-img{
      position: absolute;left: 10%;
      top:20%
    }
    .core-objectives-list {
      display: flex;
      align-items: center;

      .core-objectives-item {
        display: flex;
        flex-direction: column;
        margin-right: 170px;

        .core-objectives-item-title {
          font-weight: 400;
          font-size: 26px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 25px;
          //width: 270px;
          height: 50px;
        }

        .core-objectives-item-percent {
          font-weight: bold;
          font-size: 60px;
          color: rgba(255, 255, 255, 0.85);
          display: flex;
          align-items: flex-end;
          margin-top: 65px;
          margin-bottom: 15px;

        }

        .core-objectives-item-subTitle {
          font-weight: 400;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 32px;

        }

      }
    }
  }

  .latest-news-container {
    margin-top: 300px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .latest-news-left {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      .latest-news-left-title {
        font-weight: 500;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 33px;
        margin-top: 30px;
      }

      .latest-news-left-date {
        font-weight: 500;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 25px;
      }

      .latest-news-left-moreBtn {
        margin-top: 45px;
        width: 160px;
        height: 50px;
        border: 1px solid #808080;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      img {
        width: 620px;
        height: 350px;
      }
    }

    .latest-news-right {
      display: flex;
      flex-direction: column;
      margin-left: 20px;

      .latest-news-right-item {
        width: 600px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid rgba(169, 169, 169, 0.5);
        padding-bottom: 35px;
        margin-bottom: 20px;
        cursor: pointer;

        .latest-news-right-item-info {
          display: flex;
          flex-direction: column;
          height: 135px;
          justify-content: space-between;

          .latest-news-right-item-info-title {
            font-weight: 500;
            font-size: 18px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 33px;
            width: 300px;
          }

          .latest-news-right-item-info-date {
            font-weight: 500;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            line-height: 25px;
          }

          .latest-news-right-item-info-more {
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            display: flex;
            align-items: center;
            cursor: pointer;
          }
        }

        img {
          width: 240px;
          height: 135px;
        }
      }
    }
  }

  .partners-container {
    margin-top: 265px;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;

    img {
      width: 345px;
      height: 145px;
      margin-bottom: 20px;
    }
  }
}

</style>
<style scoped lang="less">
/deep/ .el-carousel__indicators { // 指示灯位置
  transform: unset;
  left: 250px;
  bottom: 140px;
}

/deep/ .el-carousel__button { // 默认按钮的颜色大小等
  width: 25px;
  height: 4px;
  border: none;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.45);
}

/deep/ .is-active .el-carousel__button { // 选中图片的颜色
  background: #FFFFFF;
  opacity: 1;
}


/* 在小屏幕上调整布局 */
//@media screen and (max-width: 768px) {
//  .container {
//    width: 100%;
//    flex-direction: column;
//    box-sizing: border-box;
//  }
//}

</style>

